/** Shared customer Select label — shows linked Education student when present. */

export type CustomerOptionSource = {
  id: string;
  customer_code?: string | null;
  customer_name?: string | null;
  contact_person?: string | null;
  student_name?: string | null;
  student_admission_no?: string | null;
  is_education_student_customer?: boolean;
};

/**
 * Label for customer dropdowns (Receipt voucher, statements, sales, etc.).
 * Education fee accounts are customers linked via edu_student_fee_payers —
 * prefer student identity so school cashiers find the learner, not only the guardian.
 */
export function formatCustomerOptionLabel(c: CustomerOptionSource): string {
  const code = (c.customer_code || '').trim();
  const name = (c.customer_name || '').trim();
  const student = (c.student_name || '').trim();
  const admission = (c.student_admission_no || '').trim();
  const guardian = (c.contact_person || '').trim();

  if (student) {
    const stu = admission ? `${student} (${admission})` : student;
    // Avoid "Name (adm) — Name (adm)" when customer_name was already synced to student.
    if (name && !name.toLowerCase().includes(student.toLowerCase())) {
      return code ? `${stu} — ${name} [${code}]` : `${stu} — ${name}`;
    }
    if (guardian && !stu.toLowerCase().includes(guardian.toLowerCase())) {
      return code ? `${stu} · ${guardian} [${code}]` : `${stu} · ${guardian}`;
    }
    return code ? `${stu} [${code}]` : stu;
  }

  if (name && code) return `${name} [${code}]`;
  return name || code || c.id;
}
